import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeDataset } from './file-type.dataset';
import { AzureDataLakeStoreLinkedService } from 'app/model/linkedservice/azure-data-lake-store.linkedservice';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStore.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureDataLakeStore_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureDataLakeStore_DisplayText)
    ],
    constraints: {
        linkedService : {
            model : AzureDataLakeStoreLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureDataLakeStoreFileDataset extends FileTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly GENERATED_FROM_ACTIVITY: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_GeneratedFromActivity,
        association: 'GENERATED_FROM_ACTIVITY'
    })
    public generatedFromActivity?: boolean;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
